import type { GetDietitianInvoicesParams } from "@client/clinic/getDietitianInvoicesAPI";
import type {
  CheckoutPreviewFlow,
  PreviewPlanBody,
} from "@client/clinic/PreviewPlanBody";

export const dietitianKeys = {
  base: () => ["dietitian"],
  profiles: () => [...dietitianKeys.base(), "profile"],
  profile: (dietitianId: number) => [...dietitianKeys.profiles(), dietitianId],
  plans: () => [...dietitianKeys.base(), "plans"],
  checkoutPreview: (flow: CheckoutPreviewFlow, body: PreviewPlanBody) => [
    ...dietitianKeys.base(),
    "checkout-preview",
    flow,
    body,
  ],
  currentSubscription: () => [
    ...dietitianKeys.base(),
    "subscription",
    "current",
  ],
  availableSubscriptionAddons: () => [
    ...dietitianKeys.currentSubscription(),
    "available-addons",
  ],
  invoices: (params?: GetDietitianInvoicesParams) => [
    ...dietitianKeys.base(),
    "invoices",
    params?.unpaid ?? "all",
    params?.page ?? 1,
    params?.perPage ?? 15,
  ],
  subscriptionCoupons: () => [
    ...dietitianKeys.base(),
    "subscription",
    "coupons",
  ],
  subscriptionCancellationReasons: () => [
    ...dietitianKeys.base(),
    "subscription",
    "cancellation-reasons",
  ],
  unpaidInvoicesCount: () => [
    ...dietitianKeys.base(),
    "invoices",
    "unpaid-count",
  ],
};
